export class LoginUser {
    public name: string;
    public password: string;
    constructor() {}
}
